/**
 * Copyright (c) 2021 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import React from 'react';
import { css, StyleSheet } from 'aphrodite';
import { Header as ECHeader } from '@blend/enterprise-components';

export namespace Header {
  export interface Props {
    header: string;
  }
}

const styles = StyleSheet.create({
  headerWrapper: {
    alignItems: 'center',
    display: 'flex',
    justifyContent: 'space-between',
    padding: `42px 40px`,
  },
});

export const Header: React.FC<Header.Props> = ({ header }) => {
  return (
    <div className={css(styles.headerWrapper)} data-it="Pipeline-Header">
      <ECHeader size={2}>{header}</ECHeader>
    </div>
  );
};
